<template>
    <div v-epi-edit="pagePropertyName" v-if="model.articles">
        <div class="mx-0 mt-10 mb-2">
            <div class="bg-white lg:bg-transparent slider">
                <swiper ref="slider" :options="swiperOptions">
                    <swiper-slide class="flex items-center justify-center" v-for="article in model.articles" :key="article.id">
                        <div class="relative">
                           <EpiLink v-if="article.url" :url="article.url" :title="`Les mer om ${article.heading}`">
                                <img :src="`${article.image}?${getImageParams(article.imageResizerParams)}`" />
                                <div v-if="model.view === 'classic'">
                                    <div class="left-0 right-0 py-5 pl-20 pr-20 text-white bg-gray-700 md:absolute bottom-20 top-20 lg:py-20 md:pl-20 lg:pl-40 md:bg-black md:bg-opacity-50">
                                        <div class="text-lg md:text-2xl lg:text-3xl">
                                            {{ article.heading }}
                                        </div>
                                        <span class="inline-block mt-4 btn btn-xs md:btn-sm btn-green md:mt-6">Les mer &rarr;</span>
                                    </div>
                                </div>
                                <div v-if="model.view === 'modern'">
                                    <div class="relative w-full p-10 text-black bg-white lg:absolute lg:bottom-0 lg:top-0 lg:right-0 lg:w-5/12 lg:bg-opacity-90">
                                        <div class="text-lg md:text-2xl lg:text-3xl">
                                            <div class="pb-5 text-lg border-b-2">
                                                <h2>{{article.heading}}</h2>
                                            </div>
                                            <div v-html="article.extract" class="pt-5 text-base"></div>
                                        </div>
                                        <span class="inline-block mt-4 text-blue-500 underline md:btn-sm btn-green md:mt-6 hover:no-underline hover:text-green-500">
                                            {{ article.buttonIcon }}
                                            Les mer &rarr;
                                        </span>
                                    </div>
                                </div>
                           </EpiLink>
                           <div v-else style="{display:'inline'}">
                                <img :src="`${article.image}?${getImageParams(article.imageResizerParams)}`" />
                                <div v-if="model.view === 'classic'">
                                    <div class="absolute left-0 right-0 py-5 pl-20 pr-20 text-white bg-black bg-opacity-50 bottom-20 top-20 lg:py-20 md:pl-20 lg:pl-40">
                                        <div class="text-lg md:text-2xl lg:text-3xl">
                                            {{ article.heading }}
                                        </div>
                                    </div>
                                </div>
                                <div v-if="model.view === 'modern'">
                                    <div class="relative w-full p-10 text-black bg-white lg:absolute lg:bottom-0 lg:top-0 lg:right-0 lg:w-5/12 lg:bg-opacity-90">
                                        <div class="text-lg md:text-2xl lg:text-3xl">
                                            <div class="pb-5 text-lg border-b-2">
                                                <h2>{{article.heading}}</h2>
                                            </div>
                                            <div v-html="article.extract" class="pt-5 text-base"></div>
                                        </div>
                                    </div>
                                </div>
                           </div>
                        </div>
                    </swiper-slide>
                    <div v-if="model.articles.length > 1" class="hidden p-6 text-gray-600 border border-gray-400 rounded-full swiper-button swiper-button-prev md:flex hover:border-gray-600 hover:bg-white bg-gray-50 hover:text-gray-900" slot="button-prev"></div>
                    <div v-if="model.articles.length > 1" class="hidden p-6 text-gray-600 border border-gray-400 rounded-full swiper-button swiper-button-next md:flex hover:border-gray-600 hover:bg-white bg-gray-50 hover:text-gray-900" slot="button-next"></div>
                </swiper>
            </div>
            <div v-if="model.articles.length > 1"
                 class="relative pb-4 swiper-pagination"
                 slot="pagination" />
        </div>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import EpiLink from '@/Scripts/components/atoms/EpiLink/index.vue';

export default {
    props: ['model', 'pagePropertyName'],
    components: {
        Swiper,
        SwiperSlide,
        EpiLink
    },
    data() {
        return {
            imageParams: '',
            swiperOptions: {
                loop: this.model.articles.length > 1,
                centeredSlides: true,
                effect: 'slide',
                autoHeight: false,
                autoplay: {
                    delay: 10000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
            }
        };
    },
    computed: {
        swiper() {
            return this.$refs.slider.$swiper;
        }
    },
    methods: {
        log(obj) {
            console.log(obj);
        },
        getImageParams(imageResizerParams) {
            let params = (this.model.view === 'classic' ? 'scale=both&width=1280&maxheight=410' : 'scale=both&width=1122&maxheight=388');
            return (imageResizerParams ? `${params}&${imageResizerParams}` : params);
        }
    }
};
</script>

<style scoped>

</style>
